import { render, staticRenderFns } from "./ItemChallengeComponent.vue?vue&type=template&id=53c502b0&scoped=true"
import script from "./ItemChallengeComponent.vue?vue&type=script&lang=js"
export * from "./ItemChallengeComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemChallengeComponent.vue?vue&type=style&index=0&id=53c502b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c502b0",
  null
  
)

export default component.exports